import {FC} from 'react'
import {Card, Form, Row, Col, Button, Spinner} from 'react-bootstrap'
import {LegalTinaDetail} from '../core/_models'

type Props = {
  isLoadingLegal: boolean
  legalOrigin: LegalTinaDetail
  legalPending: LegalTinaDetail
  isDifferent: (val1: any, val2: any) => boolean
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  handleCancel: () => void
  handleSubmit: () => void
  isLoadingButton: boolean
  isFormValid: boolean
}

const LegalTinaPendingForm: FC<Props> = ({
  isLoadingLegal,
  legalOrigin,
  legalPending,
  isDifferent,
  handleChange,
  handleSelectChange,
  handleCancel,
  handleSubmit,
  isLoadingButton,
  isFormValid,
}) => {
  return (
    <Row className='mb-5 h-100'>
      <Col className='h-100'>
        <Card className='h-100'>
          <Card.Header className='card-header-stretch'>
            <Card.Title className='w-100'>
              <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                <div className='title d-flex align-items-center'>
                  <span className='fa fa-file-alt px-2'></span>
                  <h3 className='text-gray-700'>Pending Review Content</h3>
                </div>
              </div>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            {!isLoadingLegal ? (
              <Form>
                <div className='row'>
                  <div className='col-12'>
                    <h3>General Information</h3>
                  </div>
                  <div className='col-md-4'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={`required ${
                          isDifferent(legalOrigin.unique_code, legalPending.unique_code)
                            ? 'label-highlight'
                            : ''
                        }`}
                      >
                        Unique Code
                      </span>
                    </Form.Label>
                    <Form.Control
                      placeholder='Enter unique code'
                      type='text'
                      name='unique_code'
                      className='required'
                      value={legalPending.unique_code || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='col-md-8'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={`required ${
                          isDifferent(legalOrigin.heading, legalPending.heading)
                            ? 'label-highlight'
                            : ''
                        }`}
                      >
                        Heading
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Enter heading'
                      name='heading'
                      className='required'
                      value={legalPending.heading || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='col-md-12'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(legalOrigin.description, legalPending.description)
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Description
                      </span>
                    </Form.Label>
                    <Form.Control
                      as='textarea'
                      rows={3}
                      placeholder='Enter description'
                      name='description'
                      value={legalPending.description || ''}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <hr />
                <div className='row'>
                  <div className='col-12'>
                    <h3>Attributes</h3>
                  </div>
                  <div className='col-md-4'>
                    <Form.Label className='required text-primary me-0 ps-0' column>
                      <span
                        className={`required ${
                          isDifferent(legalOrigin.level, legalPending.level)
                            ? 'label-highlight'
                            : ''
                        }`}
                      >
                        Level
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='number'
                      placeholder='Enter level'
                      name='level'
                      min={0}
                      value={legalPending.level ?? ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='col-md-4'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(legalOrigin.divider, legalPending.divider)
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Divider
                      </span>
                    </Form.Label>
                    <Form.Select
                      name='divider'
                      value={
                        legalPending.divider === 1 || legalPending.divider === true
                          ? '1'
                          : legalPending.divider === 0 || legalPending.divider === false
                          ? '0'
                          : ''
                      }
                      onChange={handleSelectChange}
                    >
                      <option value='' disabled>
                        Select divider
                      </option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </Form.Select>
                  </div>
                  <div className='col-md-4'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(legalOrigin.sub_issue, legalPending.sub_issue)
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Sub Issue
                      </span>
                    </Form.Label>
                    <Form.Select
                      name='sub_issue'
                      value={legalPending.sub_issue ? '1' : '0'}
                      onChange={handleSelectChange}
                    >
                      <option value='' disabled>
                        Select sub issue
                      </option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </Form.Select>
                  </div>
                  <div className='col-md-4'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(legalOrigin.upcoming_flag, legalPending.upcoming_flag)
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Upcoming Flag
                      </span>
                    </Form.Label>
                    <Form.Select
                      name='upcoming_flag'
                      value={legalPending.upcoming_flag ? '1' : '0'}
                      onChange={handleSelectChange}
                    >
                      <option value='' disabled>
                        Select upcoming flag
                      </option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </Form.Select>
                  </div>
                </div>
                <hr />
                <div className='row'>
                  <div className='col-12'>
                    <h3>References</h3>
                  </div>
                  <div className='col-md-4'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(legalOrigin.parent_id, legalPending.parent_id)
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Parent ID
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='number'
                      placeholder='Enter parent ID'
                      name='parent_id'
                      value={legalPending.parent_id ?? ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='col-md-8'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(
                            legalOrigin.recommended_keyword,
                            legalPending.recommended_keyword
                          )
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Recommended Keyword
                      </span>
                    </Form.Label>
                    <Form.Control
                      as='textarea'
                      rows={2}
                      placeholder='Enter recommended keywords'
                      name='recommended_keyword'
                      value={legalPending.recommended_keyword || ''}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className='row pt-5'>
                  <div className='col-lg-12 d-flex justify-content-end gap-3'>
                    <Button variant='default' className='btn-cancel' onClick={handleCancel}>
                      Cancel
                    </Button>
                    <Button
                      variant='primary'
                      onClick={handleSubmit}
                      disabled={isLoadingButton || !isFormValid}
                    >
                      {isLoadingButton ? (
                        <>
                          <Spinner animation='border' size='sm' className='me-2' />
                          Submit
                        </>
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </div>
                </div>
              </Form>
            ) : (
              <div
                className='d-flex align-items-center justify-content-center'
                style={{height: '50vh'}}
              >
                <Spinner animation='border' role='status' variant='primary' className='me-3' />
                <div className='loading-text'>
                  Loading
                  <span className='dot'>.</span>
                  <span className='dot'>.</span>
                  <span className='dot'>.</span>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default LegalTinaPendingForm
